import { action, observable } from "mobx";

import { LugasActivationsService } from "@api-services/games";
import { LugasAreaType } from "@data-types/user/LugasAreaType";
import type { RootStore } from "@state/stores/types";

class AreaChangeStore {
	@observable isActive: boolean = false;
	@observable targetArea: LugasAreaType | null = null;

	rootStore: RootStore;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
	}

	@action.bound
	showPopup(targetArea: LugasAreaType) {
		this.targetArea = targetArea;
		this.isActive = true;
	}

	@action.bound
	hidePopup() {
		this.isActive = false;
	}

	@action.bound
	async acceptAreaChange(): Promise<boolean> {
		try {
			const userId = this.rootStore.userAuthStore.getUserId;
			if (!userId) {
				return false;
			}

			if (!this.targetArea) {
				return false;
			}

			await LugasActivationsService.updateCurrentArea(
				userId,
				this.targetArea
			);

			if (this.rootStore.retryHandlerStore.retryFunction) {
				this.rootStore.retryHandlerStore.executeRetry();
			}
			return true;
		} catch (error) {
			console.error("Error accepting area change", error);
			return false;
		}
	}
}

export default AreaChangeStore;
